module.exports = __webpack_public_path__ + "img/tagclose.d42ddb00.svg";